/** PURE_IMPORTS_START ._AjaxObservable PURE_IMPORTS_END */
import { AjaxObservable } from './AjaxObservable';
export var ajax = AjaxObservable.create;
//# sourceMappingURL=ajax.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/dom/ajax.js
// module id = ./node_modules/rxjs/_esm5/observable/dom/ajax.js
// module chunks = vendor